// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "Prowizje OTA",
    sub: "Ile każdy kanał zatrzymuje z Twoich rezerwacji. Dzięki temu karta każdej rezerwacji pokazuje szacunek tego, co do Ciebie trafia.",
  },
  loading: "Wczytywanie prowizji…",
  loadError: {
    title: "Nie udało się wczytać prowizji",
    text: "Sprawdź połączenie i spróbuj ponownie.",
    retry: "Spróbuj ponownie",
  },
  display: {
    title: "Cena rezerwacji z OTA na karcie rezerwacji",
    totalLabel: "Tylko kwota łączna przesłana przez OTA",
    totalDesc: "Jak dotychczas: kwota rezerwacji.",
    netLabel: "Także to, co do Ciebie trafia",
    netDesc: "Oprócz kwoty łącznej karta pokazuje prowizję, VAT od prowizji i kwotę netto, którą otrzymasz.",
  },
  rates: {
    title: "Prowizja i opłaty każdej OTA",
    hint: "Wpisz %, który widzisz w extranecie każdej OTA (w Booking: „Prowizja i opłaty” ÷ „Cena całkowita”). Jeśli kanał przekazuje rzeczywistą prowizję rezerwacji, używana jest właśnie ona.",
    usual: "zwykle: {pct}%",
    airbnbNote: "Airbnb wypłaca Ci kwotę już netto: jego prowizja jest już potrącona. Zostaw puste pole (0%), chyba że Twoje połączenie otrzymuje kwotę łączną.",
    managedNote: "Te wartości procentowe są też używane w rozliczeniu z Twoim właścicielem.",
  },
  vat: {
    title: "VAT od prowizji OTA",
    hint: "Booking nalicza VAT od swojej prowizji obiektom w Hiszpanii (21%) i potrąca go z przelewu. Wpisz 0, jeśli nie jest Ci naliczany.",
  },
  errPercent: "Musi to być wartość procentowa od 0 do 100.",
  example: {
    title: "Przykład",
    sub: "Rezerwacja z {channel} na {total}",
    total: "Cena całkowita",
    commission: "Prowizja i opłaty {channel} ({pct}%)",
    vat: "VAT od prowizji ({pct}%)",
    net: "Otrzymujesz",
    foot: "To szacunek na podstawie tych wartości: OTA może przelać nieco inną kwotę (zaokrąglenia, promocje, opłaty za płatność). Jeśli kanał przekazuje rzeczywistą prowizję, karta używa właśnie jej.",
  },
  footer: {
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Prowizje zapisane",
    unsaved: "Niezapisane zmiany",
    fixErrors: "Sprawdź zaznaczone pola",
    errSave: "Nie udało się zapisać zmian. Spróbuj ponownie.",
    errInvalid: "Prowizja każdej OTA musi być wartością procentową od 0 do 100.",
  },
};
